<div class="header">
  {{ 'm/task-process/reply-to-list-title' | translate }}
</div>
<ion-content>
  <ion-list lines="none">
    <ion-item *ngFor="let user of replyToList; first as isFirst">
      <ion-label>{{ handleOrName(user) }}</ion-label>
      <ion-checkbox [(ngModel)]="user.isSelected" [disabled]="isFirst" slot="start"></ion-checkbox>
    </ion-item>
  </ion-list>
</ion-content>
<div class="footer">
  <ion-button (click)="ok()" fill="outline">
    {{ 'm/close' | translate }}
  </ion-button>
</div>
